export enum DecisionExportLogType {
    EdiPriceList = 1,
    MasterData = 2
}

(DecisionExportLogType as any).__typeName = 'DecisionExportLogType';